export default function packageSlider() {
  if ($('.js-packages__list').length) {
    $('.js-packages__list').slick({
      autoplay: false,
      arrows: false,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      draggable: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: 'unslick',
        },
      ],
    });
  }

  $(window).on('resize orientationchange', function () {
    $('.js-packages__list').slick('resize');
  });
};
